import React from 'react';
import { motion } from 'framer-motion';

// Aparición suave al entrar en pantalla
function Reveal({ children, delay = 0, as = 'div', className, ...rest }) {
  const Component = motion[as];
  return (
    <Component
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </Component>
  );
}

export default Reveal;
